import { render, staticRenderFns } from "./newMarketPrice.vue?vue&type=template&id=27214794&scoped=true"
import script from "./newMarketPrice.vue?vue&type=script&lang=js"
export * from "./newMarketPrice.vue?vue&type=script&lang=js"
import style0 from "./newMarketPrice.vue?vue&type=style&index=0&id=27214794&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27214794",
  null
  
)

export default component.exports